window.addEventListener('DOMContentLoaded',()=>{
    let buttonField = document.querySelector('#SubmitFormToHulk');
    let formField = document.querySelector('#report-download-form');
    formField.addEventListener('submit',(e)=>{
        e.preventDefault();
        buttonField.setAttribute('disabled',true);
        buttonField.classList.add('loading');
        var myHeaders = new Headers();
        myHeaders.append("X-Form-Access-Token", "4f2eff2ada8e5b72");
        myHeaders.append("Content-Type", "application/json");
        
        var raw = JSON.stringify({
          "formResponse": {
            "Work Email Address": document.querySelector('#ContactForm-work_email').value,
            "First Name": document.querySelector('#ContactForm-first_name').value,
            "Last Name": document.querySelector('#ContactForm-last_name').value,
            "Job Title": document.querySelector('#ContactForm-job_title').value,
            "Clinic/Company": document.querySelector('#ContactForm-company').value,
            "Phone": document.querySelector('#ContactForm-phone').value,
            "Report Page": document.querySelector('#ContactForm-Report_page').value
          }
        });
        
        var requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: raw,
          redirect: 'follow'
        };
        
        fetch("https://formbuilder.hulkapps.com/forms/create_response/qGw3R3QGKoVwqtWxSJZ_nQ", requestOptions)
          .then(response => response.text())
          .then(result => {
            console.log(result)
            buttonField.removeAttribute('disabled');
            buttonField.classList.remove('loading');
            document.querySelector('#showSuccessMessage')?.classList.remove('d-none');
            setTimeout(
              ()=>{
                document.querySelector('#showSuccessMessage')?.classList.add('d-none');
              }
              ,11000);
        })
          .catch(error =>{ 
            console.log('error', error)
            buttonField.removeAttribute('disabled');
            buttonField.classList.remove('loading');
            document.querySelector('#showErrorMessage')?.classList.remove('d-none');
            setTimeout(
              ()=>{
                document.querySelector('#showErrorMessage')?.classList.add('d-none');
              }
              ,7000);
        });
    })
})